import { DragEvent } from 'react';
import { showToast } from '../../../../common/domain/toast-provider';
import { moveToFolder } from '../../data/wiki-data-service';
import { getCombinedWikiData } from '../../domain/wiki-provider';
import { WikiMode } from '../../wiki-interfaces';
import { useNavigate } from 'react-router-dom';
import { useWikiStore } from '../../data/wiki-store';

interface IWikiMenuDragTargetProps {
    itemPath: string;
}

const DRAG_CLASS = 'wiki-menu__drag-target__over';

const WikiMenuDragTarget = (props: IWikiMenuDragTargetProps) => {

    const { itemPath } = props;

    const navigate = useNavigate();

    const setWikiData = useWikiStore(store => store.setWikiData);
    const setWikiMode = useWikiStore(store => store.setWikiMode);
    const openedFolders = useWikiStore(store => store.openedFolders);

    const targetOnDragOver = (evt: DragEvent<HTMLDivElement>) => {
        evt.preventDefault();
    };

    const targetOnDragEnter = (evt: DragEvent<HTMLDivElement>) => {
        evt.currentTarget.classList.add(DRAG_CLASS);
    };

    const targetOnDragLeave = (evt: DragEvent<HTMLDivElement>) => {
        evt.currentTarget.classList.remove(DRAG_CLASS);
    };

    /**
     * https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setData
     */
    const targetOnDrop = async (evt: DragEvent<HTMLDivElement>) => {
        evt.preventDefault();
        const _data = evt.dataTransfer.getData('text');

        if(_data === null ||
            _data === undefined ||
            _data.trim() === '') {
            showToast('Drop wiki menu item error.');
            return;
        }

        const sourceFile = _data;
        const targetFolder = itemPath;

        console.log(`${ sourceFile } ---> ${ targetFolder }`);

        const response = await moveToFolder(
            [...openedFolders],
            sourceFile,
            targetFolder
        );

        if(!response?.isValid) {
            showToast('Drag wiki menu item error.');
            return;
        }

        const data = getCombinedWikiData(response);
        setWikiData(data);

        setWikiMode(WikiMode.DEFAULT);
        navigate(`/wiki${ data.selectedItem }`);
    };

    return (
        <div
            onDragOver={ targetOnDragOver }
            onDragEnter={ targetOnDragEnter }
            onDragLeave={ targetOnDragLeave }
            onDrop={ targetOnDrop }
            className="wiki-menu__drag-target h-[5px] bg-slate-500 rounded my-1 hidden ml-6" />
    )
};

export default WikiMenuDragTarget;